module.exports = __webpack_public_path__ + "static/media/Soep.6c9fd8ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Soep.jpg
// module id = 325
// module chunks = 0